module.exports = __webpack_public_path__ + "static/media/Upload.bf084ed3.jpg";